import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { Label } from 'styles/typography';

// Shared building blocks for the UserBar's ActionsPalette actions (Escalations, Help & Support,
// and the notification bell). Extracted from UserBar.tsx so the bell matches the existing actions'
// icon + label + count-badge shape exactly (OLIO-3059).

export const Action = styled.div`
  display: flex;
  color: white;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const ActionLabel = styled(Label).attrs({ as: 'span' })`
  color: ${colors.white};
  white-space: nowrap;
`;

export const ActionIconContainer = styled.div<{ $count: number }>`
  display: flex;
  gap: 8px;
  padding-right: ${({ $count }) => ($count > 0 ? 7 : 0)}px;
  position: relative;
`;

export const ActionBadge = styled.span`
  align-items: center;
  align-self: flex-end;
  background: ${colors.red100};
  border-radius: 50%;
  bottom: -8px;
  color: ${colors.white};
  display: flex;
  font-size: 10px;
  height: 14px;
  justify-content: center;
  margin-left: 1px;
  position: absolute;
  right: 0px;
  width: 14px;
`;
